import { Outlet } from 'react-router-dom';
import Header from './Header.jsx';

const MainLayout = () => {
  return (
    <div className="min-h-screen bg-slate-100 font-sans">
      <Header />
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;
